import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Table, withSelectionPanel } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import { IFiltersProps, ISelectionPanelProps } from 'coreOld/types';
import { UpdateRequestForm } from 'support/components';
import { IRequest } from 'support/types';

interface IProps extends ISelectionPanelProps<IRequest>, IFiltersProps {
  data: IRequest[];
  tableColumns;
  filters: Record<string, any>;
  isLoading?: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage;
  isError?: boolean;
  setCloseSelection: Dispatch<SetStateAction<boolean>>;
  isUpdateRequestOpen?: boolean;
  setIsUpdateRequestOpen?: Dispatch<SetStateAction<boolean>>;
}

const RequestListView = ({
  data,
  tableColumns,
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  setSelectedRows,
  selectedRows,
  setCloseSelection,
  isModalOpen,
  onCheckboxClick,
  isUpdateRequestOpen,
  setIsUpdateRequestOpen,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <>
      <UpdateRequestForm
        isOpen={isUpdateRequestOpen}
        setIsOpen={setIsUpdateRequestOpen}
        selectedItems={selectedRows}
        setCloseSelection={setCloseSelection}
      />

      <Table
        data={data}
        columns={tableColumns}
        name={TableNames.SUPPORT_REQUEST_LIST}
        setSelectedRows={setSelectedRows}
        onCheckboxClick={onCheckboxClick}
        isModalOpen={isModalOpen}
        noItemsFoundText={t('messageNoSupportRequestFound')}
        isLoading={isLoading}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
        alternating={false}
        showInfoIcon
        borderBottom
        hasFilters
        hasRowSelection
      />
    </>
  );
};

export default withSelectionPanel(RequestListView);
